import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    cardContent: {
      padding: theme.spacing(2),
      paddingTop: '0px !important',
      justifyContent: 'space-between',
      display: 'flex',
      flexDirection: 'column'
    },
    dataTableStyle: {
      minHeight: '0px'
    }
  })
